import styled from 'styled-components';
export const arrowSwg = require('./components/Icons/files/arrow.svg');
const size = {
    sm: '568px',
    md: '768px',
    xl: '1200px',
    xxl: '1921px',
};
const device = {
    sm: `(min-width: ${size.sm})`,
    md: `(min-width: ${size.md})`,
    xl: `(min-width: ${size.xl})`,
    xxl: `(min-width: ${size.xxl})`,
};
const oldColors = {
    vLightBlue: '#f7f9fa',
    lightBlue: '#e8f4fb',
    blue: '#1c92dd',
    darkBlue: '#0065ab',
    navyBlue: '#0d1e2e',
    veryDarkBlue: '#1c3144',
    standardGray: '#fafafa',
    vvvLightGray: '#f3f2f2',
    vvLightGray: '#F0F0F0',
    vLightGray: '#f9f9f9',
    lightGray: '#ebeaea',
    loblloly: '#bac9ce',
    gray: '#c0c0c0',
    darkGray: '#6c6c6c',
    vDarkGray: '#4c4c4c',
    darkRed: '#dc493a',
    red: '#f45b69',
    lightYellow: '#fefaf2',
    yellow: '#f9a000',
    lightGreen: '#e3f4ec',
    green: '#26a96c',
    vgreen: '#21955f',
    darkGreen: '#255957',
    mGray: '#767676',
    lightBlack: '#272932',
    shamrockGreen: '#00965e',
    orange: '#f78154',
    blackSqueeze: '#f4f8fb',
    athensGray: '#e8e9eb',
    ghostWhite: '#f4f4f8',
    iron: '#e7e7e9',
    blackHaze: '#eeefef',
    zircon: '#e6e7e7',
    aquaHaze: '#f7f9fa',
    newLightGray: '#ececec',
    boulder: '#767676',
    vLightBlack: '#0c1e2f',
    mercury: '#e8e8e8',
    biscay: '#183059',
    approveRed: '#B51E1C',
    golden: '#caa53d',
};
const newColors = {
    white: '#ffffff',
    alabaster: '#f9f9f9',
    athensGray: '#f4f4f8',
    concrete: '#f3f2f2',
    iron: '#e7e7e9',
    alto: '#e0e0e0',
    selectiveYellow: '#fbbc05',
    selectiveYellow2: '#ffb900',
    limeade: '#7fba00',
    cornflowerBlue: '#4285f4',
    chateauGreen: '#34a853',
    cerulean: '#00a4ef',
    pomegranate: '#f25022',
    curiousBlue: '#1c92dd',
    cinnabar: '#eb4335',
    doveGray: '#6c6c6c',
    sanMarino: '#4267b2',
    matisse: '#156ba1',
    bahamaBlue: '#006e90',
    tundora: '#4d4d4d',
    tundora2: '#4c4c4c',
    blumine: '#1d4e89',
    regalBlue: '#00487c',
    mineShaft: '#2f2f2f',
    charade: '#272838',
    prussianBlue: '#003459',
    daintree: '#023436',
    bigStone: '#152935',
    black: '#000000',
    new1: '#dddcdc',
    new2: '#f3f2f2',
    new3: '#6c6c6c',
    new4: '#21955f',
    new5: '#155f3d',
    new6: '#dc493a',
    new7: '#8c2f25',
    new8: '#e8e9eb',
    new9: '#eee',
    new10: '#fbfbfb',
    new11: '#0D1E2E',
    new12: '#B4DEF8',
    new13: '#d0dbe6',
    new14: '#003961',
    new15: '#6c7f91',
    new16: '#147bbd',
    new17: '#5f7385',
};
const redesignBreakpointSizes = {
    sm: '360px',
    md: '768px',
    lg: '1280px',
    xlg: '1440px',
};
const redesignBreakpoints = {
    reSm: `(max-width: ${redesignBreakpointSizes.sm})`,
    reLesserMd: `(max-width: calc(${redesignBreakpointSizes.md} - 1px))`,
    reMd: `(max-width: ${redesignBreakpointSizes.md})`,
    reLg: `(max-width: ${redesignBreakpointSizes.lg})`,
    reXlg: `(max-width: ${redesignBreakpointSizes.xlg})`,
};
const redesignColors = {
    cannyBlue: '#00214d',
    lurkingSky: '#003780',
    wordlessRoyal: '#004db3',
    floppyAqua: '#1872e7',
    electiveAqua: '#4d9aff',
    tinySatin: '#b1d3ff',
    humbleMilky: '#f2faff',
    lameJet: '#29333d',
    realCobalt: '#465462',
    rockyGrey: '#697d8e',
    sapphire: '#899bad',
    stressfulSnow: '#b2bdc8',
    airlessPlatinium: '#e1e6ea',
    rousingPearl: '#f7f9fb',
    urgentApple: '#145039',
    pertAzure: '#197741',
    neatApple: '#259d57',
    chillAvocado: '#38c172',
    fundedRoyal: '#74d99f',
    prettyPearl: '#a8eec1',
    lightLeaf: '#e3fcec',
    numbCoffee: '#611818',
    variousAmber: '#871b1b',
    orangeSorrel: '#b82020',
    crazyRose: '#dc3030',
    ampleBrandy: '#e46464',
    gentleWine: '#f4a9a9',
    cornySatin: '#fbe7e7',
    genericMousy: '#5c4713',
    linedHazel: '#8c6d1f',
    touchyLemon: '#caa53d',
    gentleCitrion: '#f4ca64',
    modernPearl: '#fae29f',
    snappyYellow: '#fdf3d7',
    brashSnow: '#fffcf4',
    snowy: '#ffffff',
    smokeyBlush: '#f2f4f9',
    foggyMorning: '#e6f0ff',
    iceTouch: '#f0f2f4',
};
const fontSizes = {
    fontXXXSmall: '0.5625rem',
    fontXXSmall: '0.75rem',
    fontXSmall: '0.8125rem',
    fontSmall: '0.875rem',
    fontMedium: '1rem',
    fontLarge: '1.125rem',
    fontXLarge: '1.25rem',
    fontXXLarge: '2.25rem',
};
export const SSTheme = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, fontSizes), newColors), oldColors), redesignColors), redesignBreakpoints), device), { containerMaxWidth: '1920px', extrabold: 700, bold: 700, semibold: 700, normal: 400, color: redesignColors.lameJet, fontColor: '#0d1e2e', fontColorNegative: '#fff', headerBorder: '#f9f9f9', headerBackground: '#fff', background: '#fff', pageBackground: '#f9f9f9', sectionHeaderBg: '#f7f9fa', required: '#f45b69', tabSelected: '#0065ab', tabUnselected: '#6c6c6c', tabsBorderBottom: '#ebeaea', activeTabUnderline: '#0065ab', progressActive: '#0065ab', progressInactive: '#c0c0c0', tickColor: '#1c92dd', scrollIconBoxShadow: 'inset 0px -10px 20px -5px rgba(193, 193, 193, 0.5)', rightWrapperBorder: '1px solid hsla(0, 0%, 76%, 0.3)', buttonInfo: '#1c92dd', buttonDanger: '#dc493a', buttonSuccess: '#26a96c', buttonDefault: '#f9f9f9' });
export const CA = Object.assign(Object.assign(Object.assign(Object.assign({}, fontSizes), oldColors), device), { containerMaxWidth: '1920px', extrabold: 800, bold: 700, semibold: 600, normal: 400, fontColor: '#fff', fontColorNegative: '#000', headerBorder: '#f9f9f9', headerBackground: '#fff', background: '#007D8F', pageBackground: '#007D8F', sectionHeaderBg: '#007D8F', required: '#f45b69', tabSelected: '#fff', tabUnselected: '#fff', tabsBorderBottom: '#007D8F', activeTabUnderline: '#99CC00', buttonInfo: '#fff', buttonDanger: '#dc493a', buttonSuccess: '#fff', buttonDefault: '#f9f9f9', buttonBorderRadius: '20px', progressActive: '#129da0', progressInactive: '#c0c0c0', tickColor: '#99CC00', scrollIconBoxShadow: 'none', rightWrapperBorder: 'none' });
export const theme = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, fontSizes), newColors), oldColors), redesignColors), redesignBreakpoints), device), { containerMaxWidth: '1920px', extrabold: 800, bold: 700, semibold: 600, normal: 400, fontColor: '#0d1e2e', fontColorNegative: '#fff', headerBorder: '#f9f9f9', headerBackground: '#fff', background: '#fff', pageBackground: '#f9f9f9', sectionHeaderBg: '#f7f9fa', required: '#f45b69', tabSelected: '#0065ab', tabUnselected: '#6c6c6c', tabsBorderBottom: '#ebeaea', activeTabUnderline: '#0065ab', buttonInfo: '#1c92dd', buttonDanger: '#dc493a', buttonSuccess: '#26a96c', buttonDefault: '#f9f9f9', progressActive: '#0065ab', progressInactive: '#c0c0c0', tickColor: '#1c92dd', scrollIconBoxShadow: 'inset 0px -10px 20px -5px rgba(193, 193, 193, 0.5)', rightWrapperBorder: '1px solid hsla(0, 0%, 76%, 0.3)' });
export const SIEMENS = Object.assign(Object.assign({}, theme), { extrabold: 800, bold: 700, semibold: 600, normal: 400, fontColor: '#464646', required: '#f45b69', tabSelected: '#129da0', tabUnselected: '#464646', tabsBorderBottom: '#ebeaea', activeTabUnderline: '#129da0', buttonInfo: '#129da0', buttonDanger: '#8e8e8e', buttonSuccess: '#099', completedBoxBg: '#099', completedProgressBarBg: '#464646', buttonDefault: '#f9f9f9', buttonBorderRadius: '20px', progressActive: '#129da0', progressInactive: '#c0c0c0', tickColor: '#099', scrollIconBoxShadow: 'none', rightWrapperBorder: 'none', sectionHeaderBg: 'transparent' });
export const ALLIANZ = Object.assign(Object.assign({}, theme), { buttonInfo: '#007AB3', buttonDanger: '#DC3149', buttonSuccess: '#007AB3', completedBoxBg: '#138359', completedProgressBarBg: '#138359', abortedBoxBg: '#DC3149', tickColor: '#007AB3' });
export const getStatusColor = (status) => {
    switch (status) {
        case 'TO_DECIDE':
            return `${theme.yellow}`;
        case 'SIGNED':
            return `${theme.vgreen}`;
        case 'REJECTED':
            return `${theme.darkRed}`;
        case 'REJECTED_BY_OTHER':
            return `${theme.navyBlue}`;
        default:
            return `${theme.vDarkGray}`;
    }
};
export const Arrow = styled.div `
  width: 25px;
  height: 25px;
  border-radius: 2px;
  background-color: ${(props) => props.theme.lightGray};
  background-image: url(${arrowSwg});
  background-repeat: no-repeat;
  background-position: center;
  border: 0;
  display: block;
  cursor: pointer;
  transform: ${(props) => props.open ? 'rotate(-90deg)' : 'rotate(90deg)'};
`;
export const RequiredStar = styled.span `
  font-size: ${(props) => props.theme.fontSmall};
  text-align: right;
  line-height: 18px;
  color: ${(props) => props.theme.red};

  &:after {
    content: '* ';
  }
`;
